// @ts-check

import React from "react";
import "../styles/DonorCard.css";
import { transformCampaignName } from "./CampaignList";

/**
 *  @typedef {import('./coreTypes').JSDonorData} JSDonorData
 *  @typedef {import('./coreTypes').JSX} JSX
 */


/**
 * @param {{donor: JSDonorData}} props 
 * @returns {JSX}
 */
function DonorCard(props) {
	
	var campaigns = null;
	var heightOffset = 0;
	 
	if (props.donor.campaigns !== undefined
		&& props.donor.campaigns !== null
		&& Array.isArray(props.donor.campaigns)
		&& props.donor.campaigns.length !== 0)
	{
		var buildCommentBlock = (comments) => {
			var commentLis = comments.map(c => (<p>{c}</p>));
			commentLis.forEach(element => {
				heightOffset = heightOffset + 10;
			});
			return (<><p/><div className="donor-campaign-comment-container">{commentLis}</div></>);
		};

		var campLis = props.donor.campaigns.map(c => { 
			if (props.donor.campaignComments === null) return (<li>{c}</li>);
			if (props.donor.campaignComments[c] !== undefined) {
				return (<li>{transformCampaignName(c)}{buildCommentBlock(props.donor.campaignComments[c])}</li>);
			}
			else return (<li>{transformCampaignName(c)}</li>);
		});

		campaigns = (
			<ul className="donor-campaigns">
				{campLis}
			</ul>);
	}
	
	var notAlum = (props.donor.alumYear === undefined || props.donor.alumYear === null);

	var blockSizeToPixels;
	if (props.donor.blockSize === 1)
		blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
	else if (props.donor.blockSize === 2)
		blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
	else if (props.donor.blockSize === 3)
		blockSizeToPixels = (/** @type {number} */ b) => (b * 88 + (b-1) * 20);
	else if (props.donor.blockSize === 4)
		blockSizeToPixels = (/** @type {number} */ b) => (b * 60 + (b-1) * 20);
	else
		blockSizeToPixels = (/** @type {number} */ b) => (b * 65 + (b-1) * 20);

	const styling = { 
		height: blockSizeToPixels(props.donor.blockSize) + 'px'
	};
	
	return (
			<div className="donor-card" style={styling}>
				<div className="donor-name-container">
				<h4 className="donor-name">{props.donor.firstName} {props.donor.lastName}</h4>
				{!notAlum ? <p className="donor-class-of">Class of '{props.donor.alumYear}</p> : null}
			</div>
			<div className="donor-card-line"></div>
			<div>
			<span className="donor-since"> Donor Since </span><span className="donor-since-year">{props.donor.donorSince}</span>
			</div>
			{campaigns}
			</div>);
}

export default DonorCard;
